"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contentMasking = void 0;
function contentMasking(content) {
    return content ? content.replace(/./gm, "*") : "";
}
exports.contentMasking = contentMasking;
